import { useEffect, useRef } from "react";
import { isWebView } from "@/utilities/display";
import { useShellStore } from "@/features/shell/stores/shellStore";
import { useAuthStore } from "../stores/authStore";
import { isAuthed } from "../models/authState";
import { useSignIn } from "./useSignIn";

/**
 * Attempt a biometric auto-login once per app launch
 */
export const useBiometricAutoLogin = () => {
  const isLoggedIn = useAuthStore((s) => isAuthed(s));
  const { available, enrolled } = useShellStore(
    (state) => state.deviceBiometricAvailability,
  );
  const { handleSignIn, isBiometricsEnabled: isEnabled } = useSignIn();

  const hasAttempted = useRef(false);

  useEffect(() => {
    if (hasAttempted.current) return;

    if (!isEnabled || !isWebView()) return;

    // if already logged in, do not trigger a bio auto-login on logout
    if (isLoggedIn) {
      hasAttempted.current = true;
      return;
    }

    if (!available || !enrolled) return;

    hasAttempted.current = true;
    handleSignIn();
  }, [isEnabled, isLoggedIn, available, enrolled, handleSignIn]);
};
